import GlobalRequest from '../api/global-request';

const USERS_URL = 'v2/admin/users';
const USER_URL = 'v2/admin/user';

export default class UserService {
    async createUser(userData) {
        return await GlobalRequest.postRequest(USERS_URL, userData);
    }

    async updateUser(userId, userData) {
        return await GlobalRequest.patchRequest(USERS_URL + '/' + userId, userData);
    }

    async resetPassword(userData) {
        return await GlobalRequest.postRequest(USERS_URL + '/password-reset', userData);
    }

    async getUsersByCompanyId(companyId, params) {
        if (!params) {
            params = this.setNullParams();
        }
        let page_size = params.rows ? params.rows : '';
        let page = params.page ? params.page : '';
        const LINK = USERS_URL + '?company_id=' + companyId + '&page_size=' + page_size + '&page=' + (page + 1);
        return await GlobalRequest.getRequest(LINK);
    }

    async addUserToGroups(userId, groupsArr, company_id) {
        const LINK = USER_URL + '/' + userId + '/groups?company_id=' + company_id;
        return await GlobalRequest.postRequest(LINK, {
            groups: groupsArr,
        });
    }

    async getUserGroupsByUserId(params) {
        return await GlobalRequest.getRequest(`${USER_URL}/${params.user_id}/groups`, {
            params,
        });
    }

    async addUserToDepartment(userId, companyId, departments) {
        return await GlobalRequest.postRequest(USERS_URL + '/' + userId + '/department?companyId=' + companyId, {
            departments,
        });
    }

    async getUserDepartments(userId, companyId) {
        return await GlobalRequest.getRequest(USERS_URL + '/' + userId + '/department', {
            params: {
                companyId,
            },
        });
    }

    async getUserDetailsById(userId, company_id) {
        return await GlobalRequest.getRequest(USERS_URL + '/' + userId, {
            params: {
                company_id,
            },
        });
    }

    async deleteUser(userId, company_id) {
        return await GlobalRequest.deleteRequest(USERS_URL + '/' + userId, {
            params: {
                company_id,
            },
        });
    }

    setNullParams() {
        return {
            rows: null,
            page: null,
        };
    }
}
